import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Link from '@mui/material/Link';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

// assets
import CommentOutlined from '@ant-design/icons/CommentOutlined';
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import UnorderedListOutlined from '@ant-design/icons/UnorderedListOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';

const itemSx = {
  borderRadius: 2.5,
  px: 1.5,
  py: 1.1,
  '& .MuiListItemText-primary': {
    fontSize: '0.95rem',
    fontWeight: 500
  }
};

// ==============================|| HEADER PROFILE - SETTING TAB ||============================== //

export default function SettingTab() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.25, px: 0.5 }}>
        Quick links
      </Typography>
      <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 }, display: 'grid', gap: 0.75 }}>
        <Link underline="none" sx={{ color: 'inherit' }} target="_blank" rel="noopener noreferrer" href="https://liance.dev/faq">
          <ListItemButton sx={itemSx}>
            <ListItemIcon>
              <QuestionCircleOutlined />
            </ListItemIcon>
            <ListItemText primary="Help center" secondary="Read setup and workflow guidance." />
          </ListItemButton>
        </Link>
        <ListItemButton component={RouterLink} to="/profile" sx={itemSx}>
          <ListItemIcon>
            <UserOutlined />
          </ListItemIcon>
          <ListItemText primary="Profile settings" secondary="Update your profile, website, and notifications." />
        </ListItemButton>
        <ListItemButton component={RouterLink} to="/team" sx={itemSx}>
          <ListItemIcon>
            <TeamOutlined />
          </ListItemIcon>
          <ListItemText primary="Team access" secondary="Manage roles, invites, and workspace members." />
        </ListItemButton>
        <ListItemButton component={RouterLink} to="/activity" sx={itemSx}>
          <ListItemIcon>
            <UnorderedListOutlined />
          </ListItemIcon>
          <ListItemText primary="Audit activity" secondary="Open the full workspace timeline." />
        </ListItemButton>
        <Link underline="none" style={{ color: 'inherit' }} target="_blank" rel="noopener noreferrer" href="mailto:hello@liance.dev">
          <ListItemButton sx={itemSx}>
            <ListItemIcon>
              <CommentOutlined />
            </ListItemIcon>
            <ListItemText primary="Send feedback" secondary="Tell us what is missing or getting in your way." />
          </ListItemButton>
        </Link>
      </List>
    </Box>
  );
}
